module.exports = __webpack_public_path__ + "static/media/SOLICITUD DE INSCRIPCION REG E INSPSC..fe48c350.pdf";